import React from 'react';
import Loading from '../Loading';

import { useGlobal } from '../../contexts/Global/context';

import * as S from './styles';

function Button({ children, loading = false, ...rest }) {
    const defaultProps = {
        type: 'primary',
        icon: '',
        disabled: false,
    };

    const { contrastTheme } = useGlobal();

    return (
        <S.StyledButton contrastTheme={contrastTheme} {...defaultProps} {...rest}>
            {loading ? <Loading size={18} padding={0} color={contrastTheme ? '#000000' : '#FFFFFF'} /> : children}
        </S.StyledButton>
    );
}

export default Button;
